import { useEffect, useState } from 'react';

import { getCookieValue } from '@helsenorge/framework-utils/cookie';
import { setSharedCookie } from '@helsenorge/framework-utils/shared-cookies';

import { COOKIE_EXPIRY_DAYS, SUMMARY_VISITED_COOKIE_NAME, SUMMARY_VISITED_COOKIE_VALUE } from '~/cmsagent/constants/cookies';

let isFirstVisit: boolean | undefined;

const registerVisit = (): boolean => {
  if (isFirstVisit === undefined) {
    isFirstVisit = getCookieValue(SUMMARY_VISITED_COOKIE_NAME) !== SUMMARY_VISITED_COOKIE_VALUE;
    setSharedCookie(SUMMARY_VISITED_COOKIE_NAME, SUMMARY_VISITED_COOKIE_VALUE, COOKIE_EXPIRY_DAYS);
  }

  return isFirstVisit;
};

/** Nullstiller besøket slik at neste montering teller som en ny sideinnlasting. Brukes av tester. */
export const resetFirstSummaryVisit = (): void => {
  isFirstVisit = undefined;
};

/**
 * Besøksmarkøren settes ved første sideinnlasting uten brukerhandling, og er ikke et på/av-valg.
 * Svaret avgjøres én gang per sideinnlasting slik at remontering ikke leser cookien vi nettopp satte.
 */
export const useFirstSummaryVisit = (): boolean => {
  const [isFirstTime, setIsFirstTime] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsFirstTime(registerVisit());
  }, []);

  return isFirstTime;
};
